import { useMemo, useRef, useState } from 'react';
import { ReactSimpleComponentProps } from '@/custom-types';
import { AddIncidentReportFormModalContext, AddIncidentReportFormModalContextProps } from './AddIncidentReportFormModalContext';
import { CreateIncidentReportInput } from '@/graphql/generated';

export const AddIncidentReportFormModalContextProvider = ({ children }: ReactSimpleComponentProps) => {
  const reportDataRef = useRef<CreateIncidentReportInput | null>(null)
  const [isOpen, setOpen] = useState(false)

  const actions = useMemo<Omit<AddIncidentReportFormModalContextProps, 'reportData' | 'isOpen'>>(() => ({
    closeModal: () => {
      setOpen(false)
      reportDataRef.current = null
    },

    openModal: (reportData?: CreateIncidentReportInput) => {
      setOpen(true)

      if (reportData) reportDataRef.current = reportData
    },
  }), [])

  return (
    <AddIncidentReportFormModalContext.Provider value={{ ...actions, isOpen, reportData: reportDataRef.current}}>
      {children}
    </AddIncidentReportFormModalContext.Provider>
  )
}
